import {
    Route,
    Routes,
} from 'react-router-dom';
import {RequirePermission} from '../../utils/RequirePermission.tsx';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from "./pages/EditPage.tsx";
import {AddPage as PhaseAddPage} from "../phases/pages/AddPage.tsx";
import {EditPage as PhaseEditPage} from "../phases/pages/EditPage.tsx";
import {AddPage as StepAddPage} from "../steps/pages/AddPage.tsx";
import {EditPage as StepEditPage} from "../steps/pages/EditPage.tsx";


export const PlaybooksLayout = () => {
    return (
        <Routes>
            <Route
                path='/'
                element={
                    <RequirePermission action='ListPlaybooks' redirectTo='/'>
                        <IndexPage/>
                    </RequirePermission>
                }
            />
            <Route
                path='add'
                element={
                    <RequirePermission action='CreatePlaybook' redirectTo='/playbooks'>
                        <AddPage/>
                    </RequirePermission>
                }
            />
            <Route
                path=':id'
                element={
                    <RequirePermission action='GetPlaybook' redirectTo='/playbooks'>
                        <EditPage/>
                    </RequirePermission>
                }
            />
            {/*
              Phase nested routes. :id is the playbookId; :phaseId is the phase's id.
              Phases live under /playbooks/:id/phases/... — they have no top-level route.
            */}
            <Route
                path=':id/phases/add'
                element={
                    <RequirePermission action='CreatePhase' redirectTo='/playbooks'>
                        <PhaseAddPage/>
                    </RequirePermission>
                }
            />
            <Route
                path=':id/phases/:phaseId'
                element={
                    <RequirePermission action='GetPhase' redirectTo='/playbooks'>
                        <PhaseEditPage/>
                    </RequirePermission>
                }
            />
            {/*
              Step nested routes (FNP-85). :id is the playbookId; :phaseId is
              the phase's id; :stepId is the step's id. Steps live under
              /playbooks/:id/phases/:phaseId/steps/... — no top-level route.
            */}
            <Route
                path=':id/phases/:phaseId/steps/add'
                element={
                    <RequirePermission action='CreateStep' redirectTo='/playbooks'>
                        <StepAddPage/>
                    </RequirePermission>
                }
            />
            <Route
                path=':id/phases/:phaseId/steps/:stepId'
                element={
                    <RequirePermission action='GetStep' redirectTo='/playbooks'>
                        <StepEditPage/>
                    </RequirePermission>
                }
            />
        </Routes>
    );
};
